export enum AuthorityEnum {
  Extern = -1,
  Guest = 1,
  User = 2,
  Privileged = 3,
  Administrator = 4,
  SuperAdmin = 5,
}
